import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import type { components } from "../../api/schema.gen";

export type PortfolioDTO = components["schemas"]["PortfolioDTO"];
export type PositionView = components["schemas"]["PositionViewDTO"];
export type PortfolioSummary = components["schemas"]["PortfolioSummaryDTO"];

export const PORTFOLIO_KEY = ["portfolio"] as const;

export function usePortfolio() {
  return useQuery({
    queryKey: PORTFOLIO_KEY,
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/positions", { signal });
      if (error || !data) throw new Error(String(error ?? "no data"));
      return data;
    },
    // staleTime поменьше, чем у скринера — портфель чаще обновляется (записал
    // купон → хочется сразу увидеть новый realised, а не ждать 5 минут).
    staleTime: 30_000,
  });
}
